import React, { useState } from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { ZoomIn, ZoomOut, X, Maximize2, Minimize2 } from "lucide-react";
import { InvoicePreview } from "./InvoicePreview";

/**
 * PreviewModal - Modal for viewing invoice/quote preview with zoom
 */
export const PreviewModal = ({ 
  open, 
  onClose, 
  invoice, 
  company,
  type = "invoice" 
}) => {
  const [scale, setScale] = useState(0.8);
  const [isFullscreen, setIsFullscreen] = useState(false);

  const handleZoomIn = () => {
    setScale(prev => Math.min(prev + 0.2, 1.5));
  };

  const handleZoomOut = () => {
    setScale(prev => Math.max(prev - 0.2, 0.4));
  };

  const handleReset = () => {
    setScale(0.8);
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent 
        size={isFullscreen ? "full" : "xl"} 
        className={`p-0 overflow-hidden ${isFullscreen ? "max-w-[95vw] max-h-[95vh] h-[95vh]" : "max-w-4xl max-h-[90vh]"}`}
      >
        {/* Toolbar */}
        <div className="flex items-center justify-between px-4 py-3 bg-slate-100 border-b">
          <h3 className="font-semibold text-slate-700">
            {type === "quote" ? "Offert" : "Faktura"} - Förhandsgranskning
          </h3>
          <div className="flex items-center gap-2">
            <Button variant="outline" size="sm" onClick={handleZoomOut} disabled={scale <= 0.4}>
              <ZoomOut size={16} />
            </Button>
            <span className="text-sm text-slate-600 w-16 text-center">
              {Math.round(scale * 100)}%
            </span>
            <Button variant="outline" size="sm" onClick={handleZoomIn} disabled={scale >= 1.5}>
              <ZoomIn size={16} />
            </Button>
            <Button variant="outline" size="sm" onClick={handleReset}>
              100%
            </Button>
            <div className="w-px h-6 bg-slate-300 mx-2" />
            <Button 
              variant="outline" 
              size="sm" 
              onClick={() => setIsFullscreen(!isFullscreen)}
            >
              {isFullscreen ? <Minimize2 size={16} /> : <Maximize2 size={16} />}
            </Button>
          </div>
        </div>

        {/* Preview area */}
        <div 
          className="overflow-auto bg-slate-200 p-8 flex justify-center"
          style={{ height: isFullscreen ? "calc(95vh - 60px)" : "calc(90vh - 120px)" }}
        >
          <div style={{ transformOrigin: "top center" }}>
            <InvoicePreview 
              invoice={invoice} 
              company={company} 
              type={type}
              scale={scale}
            />
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default PreviewModal;
